import axios from 'axios'
import config from '@/f1/config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL_v2;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v2`;
  }
}
const baseUrl = getApiHost();
const http_v2 = axios.create({
  baseURL: baseUrl,
  timeout: 600000,
});

http_v2.interceptors.request.use((request) => { if(request.data) { request.headers['Content-Type'] = 'application/json'; } return request; });
http_v2.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http_v2; }

export default http_v2
